import React from 'react';

export function SortDownIcon({ size = 16, color = 'currentColor', style, ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color, ...style }}
      {...props}
    >
      <path
        d="M13.3346 10V2H10.668V10H9.33462C9.06497 10 8.82188 10.1624 8.7187 10.4115C8.61551 10.6607 8.67255 10.9474 8.86321 11.1381L11.5299 13.8047C11.7902 14.0651 12.2123 14.0651 12.4727 13.8047L15.1394 11.1381C15.33 10.9474 15.3871 10.6607 15.2839 10.4115C15.1807 10.1624 14.9376 10 14.6679 10H13.3346Z"
        fill="currentColor"
      />
      <path d="M8.0013 4.66667H0.667969V2H8.0013V4.66667Z" fill="currentColor" />
      <path d="M0.667969 9.33333H8.0013V6.66667H0.667969V9.33333Z" fill="currentColor" />
      <path d="M0.667969 14H8.0013V11.3333H0.667969V14Z" fill="currentColor" />
    </svg>
  );
}
